'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M9.6 5.455c0-.449.362-.819.8-.819h3.2c.438 0 .8.37.8.819v.818H9.6zM8 6.273v-.818C8 4.103 9.078 3 10.4 3h3.2C14.922 3 16 4.103 16 5.455v.818h3.2c.442 0 .8.366.8.818a.81.81 0 0 1-.8.818h-.8v10.637C18.4 19.897 17.322 21 16 21H8c-1.322 0-2.4-1.103-2.4-2.454V7.909h-.8a.81.81 0 0 1-.8-.818.81.81 0 0 1 .8-.818H8m-.8 1.636v10.637c0 .448.362.818.8.818h8c.438 0 .8-.37.8-.819V7.91H7.2m3.2 2.455c.442 0 .8.366.8.818v4.909a.81.81 0 0 1-.8.818.81.81 0 0 1-.8-.818v-4.91a.81.81 0 0 1 .8-.817m4 .818a.81.81 0 0 0-.8-.818.81.81 0 0 0-.8.818v4.909a.81.81 0 0 0 .8.818.81.81 0 0 0 .8-.818z" clipRule="evenodd" /></svg>;
const IconDelete = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconDelete;